import React, { FC } from "react";
import "./tableHeaderCards.scss";
import { useTranslation } from "react-i18next";
import { TableCard } from "../../../common/types/tableCardType";

export interface CardsProps {
  cards?: TableCard[];
  cardsContainerStyle?: string;
  cardHeadlineStyle?: string;
  cardStyle?: string;
}
const TableHeaderCards: FC<CardsProps> = ({
  cards,
  cardsContainerStyle = "",
  cardHeadlineStyle = "",
  cardStyle = "",
}) => {
  const { t } = useTranslation();

  return (
    <div className={`cards-main-container  ${cardsContainerStyle}`}>
      {cards && cards.map((val, index) => (
        <div
          key={`${val.headline}${index}`}
          className={`card-container border-style ${cardStyle}`}
        >
          {<val.icon />}
          <div className={`card-headline-texts ${cardHeadlineStyle}`}>
            <span className="card-number">{val.value}</span>
            <p className="card-headline-text" data-tooltip={val.headline}>
              {val.headline}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TableHeaderCards;
